var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('footer',[_vm._m(0),_vm._v(" "),_c('div',{staticStyle:{"vertical-align":"middle","margin-top":".5rem"}},[_vm._v("© "+_vm._s(_setup.date))])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('a',{staticClass:"dealerkit-footer-logo",attrs:{"href":"https://dealerkit.com"}},[_c('img',{attrs:{"src":"/images/dealerkit-logo.png","alt":"DealerKit Logo","width":"100"}})])
}]

export { render, staticRenderFns }